import React, { memo } from 'react';
import { AnimatedLoader } from '@ditioas/web-ui';

const FullscreenLoading = () => (
  <div className="flex w-full justify-center pt-20">
    <AnimatedLoader className="m-auto size-12" />
  </div>
);

export default memo(FullscreenLoading);
